@if (hasImage()) {
  <div class="file-list">
    @for (file of filesData(); track $index) {
      <div class="file-card">
        <button
          class="file-info-wrapper"
          [matTooltip]="'OTHER.DOWNLOAD' | translate"
          matTooltipClass="ehd-tooltip"
          (click)="onFileClick(file, $event)"
        >
          @if (isImage(file)) {
            <img class="file-preview" [src]="imageSource(file)" alt="" />
          } @else {
            <div class="file-info">
              <div class="file-name">{{ file.fileName }}</div>
              <div class="file-extension">{{ file.extention }}</div>
            </div>
          }
        </button>
      </div>
    }
  </div>
} @else {
  @for (file of filesData(); track $index) {
    <div class="download-links-wrapper">
      <app-download-link
        [fileData]="file"
        [style.width]="'100%'"
        [showIcon]="true"
      ></app-download-link>
    </div>
  }
}
